/** What ViaCEP answers for a CEP (`erro` when it doesn't exist). */
type ViaCepAddress = {
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean | string;
};

/** A Brazilian address as ViaCEP knows it (a field it doesn't know comes empty). */
export type CepAddress = { street: string; neighborhood: string; city: string; state: string };

/**
 * The address of a CEP (8 digits), from ViaCEP: `null` when the CEP doesn't exist (or isn't 8 digits: nothing is
 * asked). Rejects when offline, when ViaCEP is down or when the signal aborts (then the address is typed by hand).
 */
export const lookupCep = async (cep: string, signal?: AbortSignal): Promise<CepAddress | null> => {
  if (!/^\d{8}$/.test(cep)) return null;
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { signal });
  if (!response.ok) throw new Error(`ViaCEP ${response.status}`);
  const address: ViaCepAddress = await response.json();
  if (address.erro) return null;
  return {
    street: address.logradouro || "",
    neighborhood: address.bairro || "",
    city: address.localidade || "",
    state: address.uf || "",
  };
};
